import * as types from '../common/types'

export const openModal = ({
  data,
  modalId
}: {
  data?: object
  modalId: string
}) => ({
  type: types.OPEN_MODAL,
  data,
  modalId
})

export const closeModal = (modalId: string) => ({
  type: types.CLOSE_MODAL,
  modalId
})
